import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { ExpertGroupPortalService } from '../../services/expert-group-portal.service'

@Component({
  selector: 'app-futures-explorer',
  templateUrl: './futures-explorer.component.html',
  styleUrls: ['./futures-explorer.component.scss']
})
export class FuturesExplorerComponent implements OnInit {
  iframeUrl: SafeUrl
  expertGroupPortal: ExpertGroupPortal
  constructor(
    private sanitizer: DomSanitizer,
    private expertGroupPortalService: ExpertGroupPortalService
  ) {}

  async ngOnInit() {
    this.expertGroupPortal =
      await this.expertGroupPortalService.getExpertGroupPortalById('ai-futures')

    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://futures-explorer.jamieberryhill.com'
    )
  }
}
